import { CSSObject } from '@chakra-ui/react';
import { RaceDetailsSchema } from '@/views/races/RaceDetails/styles/RaceDetails.styles';

export const raceDetailsStyles: RaceDetailsSchema = {
  flexExoticsHeadingRight: { alignItems: ['flex-end', 'center'] },
  buttonStyledGroupedProps: {
    variant: 'odds',
    boxSize: '34px',
    minWidth: '34px',
    minHeight: '34px',
    borderRadius: 'base',
    lineHeight: 'normal',
    sx: {
      '&[data-hasPromo="true"]': {
        minW: 12,
        '.btn-span': {
          pl: 0.5,
        },
      },
      '&[data-closed="true"][data-active="false"]': {
        border: '2px solid rgba(255, 255, 255, 0.08)',
        bg: 'transparent',
        boxShadow: 'none',
        borderRadius: 'base',
        '.btn-span': {
          color: 'whiteAlpha.500',
        },
      },
    },
  },
};

export const FlexPageHeaderTitleWrapper: CSSObject = {
  mx: ['2', null, null, '0'],
};

export const ButtonGroupWrapper: CSSObject = {
  gap: '1',
  '&&': {
    '.quaddie': {
      border: '2px solid',
      borderColor: 'alpha.100',
      boxShadow:
        '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
      '.btn-span': {
        gap: '0',
      },

      '&[data-active="false"]': {
        boxShadow:
          '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
        bg: 'transparent',
        color: 'white',
        textShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)',
        border: '2px solid',
        borderColor: 'alpha.100',
      },

      '&.active': {
        border: '2px solid',
        borderColor: 'alpha.100',
        bg: 'blackAlpha.500',
        color: 'beta.400',
        textShadow: '0px 0px 9px rgba(243, 100, 23, 0.5)',
        px: '2',
      },
      '&:hover': {
        bg: 'alpha.600',
      },
    },
  },
};

export const CountdownTimerContainer: CSSObject = {
  '.chakra-badge': {
    boxSizing: 'content-box',
  },
};

export const RaceAndTimerContainer: CSSObject = {
  py: '4px',
  borderRadius: 'base',
  color: 'white',
  flexDirection: 'row',
};

export const TextRaceConditions: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'normal',
  _after: {
    content: `""`,
    w: '1px',
    h: '4',
    bg: 'whiteAlpha.200',
    pos: 'relative',
    mx: '1.5',
  },
};

export const ResultedStatusLabel: CSSObject = {
  color: 'white',
  bg: 'green.500',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  textTransform: 'uppercase',
};

export const RaceStatusText: CSSObject = {
  color: 'blackAlpha.800',
  bg: 'beta.800',
  boxShadow:
    '0px 2px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.25) inset',
  py: '0.5',
  textTransform: 'uppercase',
};

export const RaceDetailsHeading: CSSObject = {
  color: 'white',
  textTransform: 'none',
  fontFamily: 'Staatliches',
  fontSize: 'md',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: 'normal',
  minW: '45px',
  svg: {
    color: 'white',
  },
};

export const RaceRunnerListWrapper: CSSObject = {
  m: '0',
  pt: '3',
};

export const RaceRunnerList: CSSObject = {
  bg: 'transparent',
  p: '0',
  '> div.chakra-stack:first-child': {
    pb: 2,
    '> div.chakra-stack': {
      '> div.chakra-stack': {
        '> div.chakra-stack:last-child': {
          mt: 0,
        },
      },
    },
  },
};

export const TextTitle: CSSObject = {
  fontFamily: 'Staatliches',
  textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  fontSize: 'lg',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: 'normal',
  textTransform: 'uppercase',
  color: 'white',
};

export const RaceName: CSSObject = {
  fontFamily: 'body',
  fontSize: 'xs',
  fontStyle: 'normal',
  fontWeight: 'bold',
  lineHeight: 'normal',
  textTransform: 'capitalize',
  color: 'white ',
};

export const InfoContainer: CSSObject = {
  mb: '0',
  mt: '1',
  mx: ['2', null, null, '0'],
  pb: '1.5',
  pt: '1',
};

export const RaceRunnerHeadingContainer: CSSObject = {
  columnGap: '0',
  '.chakra-switch__track': {
    background: 'blackAlpha.600',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 2px 2px 0px rgba(0, 0, 0, 0.25) inset',
    '& .chakra-switch__thumb': {
      bg: 'white',
      '&[data-checked]': { bg: 'beta.300' },
    },
  },
  svg: {
    color: 'white',
  },
};

export const RaceRunnerListHeadings: CSSObject = {
  minH: '36px',
  mr: '2',
  pb: '2',
  alignItems: 'center',
  '> div > p': {
    // fontWeight: 'bold',
    textTransform: 'uppercase',
  },
};

export const RaceRunnerPropositionHeadingContainer: CSSObject = {
  '&&': {
    px: '0',
    w: '12',
  },
  svg: {
    color: 'white',
  },
};

export const RaceRunnerWinPlaceContainer: CSSObject = {
  columnGap: '1',
  '&&&': {
    p: {
      color: 'white',
      textTransform: 'none',
      fontFamily: 'body',
      fontSize: '2xs',
      fontStyle: 'normal',
      fontWeight: 'bold',
      lineHeight: 'normal',
      minW: '45px',
      svg: {
        color: 'white',
      },
    },
  },
};

export const RaceResultListWrapper: CSSObject = {
  flexDirection: 'column',
};

export const ShowMoreText: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  mb: '2',
  cursor: 'pointer',
  fontWeight: 'bold',
};
